import { auth } from "../firebase";
import { API_BASE_URL } from "../Variables";

// Admin visitor counter: one POST /api/stats/visit per browser and per day (day in Africa/Tunis, as the API).
// The memo below only avoids duplicates; it proves nothing: the API decides what is counted
// (robots and the Admin role are ignored server-side). Never blocking, never a visible error.
const MEMO = "lina.visit.day";

export const tunisDay = (now = new Date()) =>
  new Intl.DateTimeFormat("en-CA", { timeZone: "Africa/Tunis", year: "numeric", month: "2-digit", day: "2-digit" }).format(now);

function remembered(day) {
  try { return window.localStorage.getItem(MEMO) === day; } catch { return false; }
}
function remember(day) {
  try { window.localStorage.setItem(MEMO, day); } catch { /* storage unavailable: the server limit still applies */ }
}

export async function recordVisit(now = new Date()) {
  try {
    const day = tunisDay(now);
    if (remembered(day)) return false;
    const url = new URL("stats/visit", API_BASE_URL).href;
    // Wait for Firebase to restore the session: a signed-in Admin must be recognised (and ignored) by the API.
    await auth.authStateReady?.();
    const user = auth.currentUser;
    let sent = false;
    if (user) {
      const token = await user.getIdToken();
      // No keepalive here: with an Authorization header it needs a CORS preflight, refused by some browsers in keepalive mode.
      const response = await fetch(url, { method: "POST", headers: { Authorization: `Bearer ${token}` } });
      sent = response.ok;
    } else if (typeof navigator !== "undefined" && typeof navigator.sendBeacon === "function") {
      sent = navigator.sendBeacon(url);
    } else {
      const response = await fetch(url, { method: "POST", keepalive: true, credentials: "omit" });
      sent = response.ok;
    }
    if (sent) remember(day);
    return sent;
  } catch {
    return false; // silent: the visit is simply not counted
  }
}

// Called once when the app starts, after the first paint (idle time when available).
export function scheduleVisit() {
  const run = () => { recordVisit(); };
  if (typeof window === "undefined") return;
  if (typeof window.requestIdleCallback === "function") window.requestIdleCallback(run, { timeout: 5000 });
  else window.setTimeout(run, 2000);
}
